import classes from "./premiumPlanCards.module.css";
import cx from "classnames";

const SalesTag = ({
  item,
  extraClass = null,
  isAbsolute = true,
  isMobile = false
}) => {
  const { discountPercentage, recommended } = item;
  return (
    <div
      className={cx(
        discountPercentage
          ? classes.saleDiscount
          : classes.saleDiscountNoDiscount,
        !isAbsolute ? classes.positionRelative : null,
        "flex justify-center"
      )}
    >
      {discountPercentage ? (
        <div className={cx(classes.percentDiscount, extraClass)}>
          Save {item.discountPercentage}%
          {recommended && isMobile ? " (Recommended) " : null}
          <img
            src="/hire/christmas-cap.svg"
            alt="christmas"
            height="18"
            width="28"
          />
        </div>
      ) : null}
    </div>
  );
};
export default SalesTag;
